import { fetchNotifications, fetchNotificationsUnread } from './actions';

export const notificationsActions = {
    fetchNotifications,
    fetchNotificationsUnread,
};
